var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSickNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.641,
    height: 55.618,
    viewBox: "0 0 42.641 55.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".abc{fill:none;}.bcd{fill:currentColor;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "abc",
    d: "M328,384h5.562v5.562H328Z",
    transform: "translate(-298.337 -341.359)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "abc",
    d: "M72,16V71.618h42.641V16Zm38.933,51.91H75.708v-48.2h9.27v3.244a2.317,2.317,0,0,0,2.317,2.317H99.346a2.317,2.317,0,0,0,2.317-2.317V19.708h9.27Z",
    transform: "translate(-72 -16)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "abc",
    d: "M200.685,51.244a2.317,2.317,0,0,1-2.317,2.317H186.317A2.317,2.317,0,0,1,184,51.244V48h16.685Z",
    transform: "translate(-171.022 -44.292)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "abc",
    d: "M328,384h5.562v5.562H328Z",
    transform: "translate(-298.337 -341.359)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "abc",
    d: "M200.685,16v6.952a2.317,2.317,0,0,1-2.317,2.317H186.317A2.317,2.317,0,0,1,184,22.952V16Z",
    transform: "translate(-171.022 -16)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "abc",
    d: "M328,384h5.562v5.562H328Z",
    transform: "translate(-298.337 -341.359)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.804 3.706)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bcd",
    d: "M102.22,8H64.813A.813.813,0,0,0,64,8.813V57.6a.813.813,0,0,0,.813.813H102.22a.813.813,0,0,0,.813-.813V8.813A.813.813,0,0,0,102.22,8ZM77.011,9.626H90.022v5.286a1.221,1.221,0,0,1-1.22,1.22H78.231a1.221,1.221,0,0,1-1.22-1.22Zm1.22,8.132H88.8a2.849,2.849,0,0,0,2.846-2.846V12.879h6.505V53.538H68.879V12.879h6.505v2.033A2.849,2.849,0,0,0,78.231,17.758Zm23.176,39.033H65.626V9.626h9.758v1.626H68.066a.813.813,0,0,0-.813.813V54.352a.813.813,0,0,0,.813.813h30.9a.813.813,0,0,0,.813-.813V12.066a.813.813,0,0,0-.813-.813H91.648V9.626h9.758Z",
    transform: "translate(-64 -8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bcd",
    d: "M132.879,112.813a.813.813,0,1,0-1.626,0v2.44h-2.44a.813.813,0,0,0,0,1.626h2.44v2.44a.813.813,0,0,0,1.626,0v-2.44h2.44a.813.813,0,1,0,0-1.626h-2.44Z",
    transform: "translate(-121.495 -101.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bcd",
    d: "M128,216.813a.813.813,0,0,0,.813.813h24.4a.813.813,0,1,0,0-1.626h-24.4A.813.813,0,0,0,128,216.813Z",
    transform: "translate(-121.495 -194.857)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bcd",
    d: "M153.209,248h-24.4a.813.813,0,0,0,0,1.626h24.4a.813.813,0,1,0,0-1.626Z",
    transform: "translate(-121.495 -223.604)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bcd",
    d: "M153.209,280h-24.4a.813.813,0,0,0,0,1.626h24.4a.813.813,0,1,0,0-1.626Z",
    transform: "translate(-121.495 -252.352)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bcd",
    d: "M143.451,312H128.813a.813.813,0,0,0,0,1.626h14.637a.813.813,0,0,0,0-1.626Z",
    transform: "translate(-121.495 -281.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bcd",
    d: "M297.626,312h-.813a.813.813,0,0,0,0,1.626h.813a.813.813,0,0,0,0-1.626Z",
    transform: "translate(-272.418 -281.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bcd",
    d: "M325.692,376h-4.879a.813.813,0,0,0-.813.813v4.879a.813.813,0,0,0,.813.813h4.879a.813.813,0,0,0,.813-.813v-4.879A.813.813,0,0,0,325.692,376Zm-.813,4.879h-3.253v-3.253h3.253Z",
    transform: "translate(-293.978 -338.593)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSickNote);
export default __webpack_public_path__ + "static/media/sick_note.be6599b4.svg";
export { ForwardRef as ReactComponent };